import React from 'react'

import { SvgImage } from 'components/SvgImage'

import checkIcon from 'assets/images/sprite/checkbox-check-white.svg'

import { StyledStepper as S } from './Stepper.styles'

const DEFAULT_FILL_DURATION_MS = 300

type TStepperCheckpoint = {
  id: string | number
  isReached: boolean
  progressToNext?: number
}

type TStepperProps = {
  checkpoints: TStepperCheckpoint[]
  fillDurationMs?: number
  className?: string
}

export const Stepper: React.FC<TStepperProps> = ({
  checkpoints,
  fillDurationMs = DEFAULT_FILL_DURATION_MS,
  className,
}) => (
  <S.Root className={className}>
    {checkpoints.map(({ id, isReached, progressToNext }) => (
      <React.Fragment key={id}>
        <S.Checkpoint $isReached={isReached}>
          {isReached && <SvgImage svg={checkIcon} width={20} height={20} />}
        </S.Checkpoint>
        {progressToNext !== undefined && (
          <S.Segment>
            <S.SegmentFill
              $fillDurationMs={fillDurationMs}
              style={{ width: `${progressToNext * 100}%` }}
            />
          </S.Segment>
        )}
      </React.Fragment>
    ))}
  </S.Root>
)
